import { agroApi } from "../../api";
import { ResponseDataGet } from "../../../../models/responseDataGet";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { Paths } from "../../../../paths";

export const farmCategoryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getFarmCategoryList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.farmCategory }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getFarmCategoryById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.farmCategory }/${ id }`,
		method: 'GET',
	  }),
	}),

	addFarmCategory: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.farmCategory }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editFarmCategory: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.farmCategory }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteFarmCategory: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.farmCategory }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetFarmCategoryListQuery,
  useGetFarmCategoryByIdQuery,
  useAddFarmCategoryMutation,
  useEditFarmCategoryMutation,
  useDeleteFarmCategoryMutation,
  useLazyGetFarmCategoryListQuery
} = farmCategoryApi;
